var map = {
	"./GAMKONORA_ch1_20210921001149_T.jpg": 1989,
	"./GAMKONORA_ch1_20210921002649_T.jpg": 1990,
	"./GAMKONORA_ch1_20210921004149_T.jpg": 1991,
	"./GAMKONORA_ch1_20210921005649_T.jpg": 1992,
	"./GAMKONORA_ch1_20210921011149_T.jpg": 1993,
	"./GAMKONORA_ch1_20210921012649_T.jpg": 1994,
	"./GAMKONORA_ch1_20210921014149_T.jpg": 1995,
	"./GAMKONORA_ch1_20210921015649_T.jpg": 1996,
	"./GAMKONORA_ch1_20210921021149_T.jpg": 1997,
	"./GAMKONORA_ch1_20210921022649_T.jpg": 1998,
	"./GAMKONORA_ch1_20210921024149_T.jpg": 1999,
	"./GAMKONORA_ch1_20210921025649_T.jpg": 2000,
	"./GAMKONORA_ch1_20210921031149_T.jpg": 2001,
	"./GAMKONORA_ch1_20210921032649_T.jpg": 2002,
	"./GAMKONORA_ch1_20210921034149_T.jpg": 2003,
	"./GAMKONORA_ch1_20210921035649_T.jpg": 2004,
	"./GAMKONORA_ch1_20210921041149_T.jpg": 2005,
	"./GAMKONORA_ch1_20210921042649_T.jpg": 2006,
	"./GAMKONORA_ch1_20210921044149_T.jpg": 2007,
	"./GAMKONORA_ch1_20210921045649_T.jpg": 2008,
	"./GAMKONORA_ch1_20210921051149_T.jpg": 2009,
	"./GAMKONORA_ch1_20210921052649_T.jpg": 2010,
	"./GAMKONORA_ch1_20210921054149_T.jpg": 2011,
	"./GAMKONORA_ch1_20210921055649_T.jpg": 2012,
	"./GAMKONORA_ch1_20210921061149_T.jpg": 2013,
	"./GAMKONORA_ch1_20210921062649_T.jpg": 2014,
	"./GAMKONORA_ch1_20210921064149_T.jpg": 2015,
	"./GAMKONORA_ch1_20210921065649_T.jpg": 2016,
	"./GAMKONORA_ch1_20210921071149_T.jpg": 2017,
	"./GAMKONORA_ch1_20210921072649_T.jpg": 2018,
	"./GAMKONORA_ch1_20210921074149_T.jpg": 2019,
	"./GAMKONORA_ch1_20210921075649_T.jpg": 2020,
	"./GAMKONORA_ch1_20210921081149_T.jpg": 2021,
	"./GAMKONORA_ch1_20210921082649_T.jpg": 2022,
	"./GAMKONORA_ch1_20210921084149_T.jpg": 2023,
	"./GAMKONORA_ch1_20210921085649_T.jpg": 2024,
	"./GAMKONORA_ch1_20210921091149_T.jpg": 2025,
	"./GAMKONORA_ch1_20210921092649_T.jpg": 2026,
	"./GAMKONORA_ch1_20210921094149_T.jpg": 2027,
	"./GAMKONORA_ch1_20210921095649_T.jpg": 2028,
	"./GAMKONORA_ch1_20210921101149_T.jpg": 2029,
	"./GAMKONORA_ch1_20210921102649_T.jpg": 2030,
	"./GAMKONORA_ch1_20210921104149_T.jpg": 2031,
	"./GAMKONORA_ch1_20210921105649_T.jpg": 2032,
	"./GAMKONORA_ch1_20210921111149_T.jpg": 2033,
	"./GAMKONORA_ch1_20210921112649_T.jpg": 2034,
	"./GAMKONORA_ch1_20210921114149_T.jpg": 2035,
	"./GAMKONORA_ch1_20210921115649_T.jpg": 2036,
	"./GAMKONORA_ch1_20210921121149_T.jpg": 2037,
	"./GAMKONORA_ch1_20210921122649_T.jpg": 2038,
	"./GAMKONORA_ch1_20210921124149_T.jpg": 2039,
	"./GAMKONORA_ch1_20210921125649_T.jpg": 2040,
	"./GAMKONORA_ch1_20210921131149_T.jpg": 2041,
	"./GAMKONORA_ch1_20210921132649_T.jpg": 2042,
	"./GAMKONORA_ch1_20210921134149_T.jpg": 2043,
	"./GAMKONORA_ch1_20210921135649_T.jpg": 2044,
	"./GAMKONORA_ch2_20210921001149_T.jpg": 2045,
	"./GAMKONORA_ch2_20210921002649_T.jpg": 2046,
	"./GAMKONORA_ch2_20210921004149_T.jpg": 2047,
	"./GAMKONORA_ch2_20210921005649_T.jpg": 2048,
	"./GAMKONORA_ch2_20210921011149_T.jpg": 2049,
	"./GAMKONORA_ch2_20210921012649_T.jpg": 2050,
	"./GAMKONORA_ch2_20210921014149_T.jpg": 2051,
	"./GAMKONORA_ch2_20210921015649_T.jpg": 2052,
	"./GAMKONORA_ch2_20210921021149_T.jpg": 2053,
	"./GAMKONORA_ch2_20210921022649_T.jpg": 2054,
	"./GAMKONORA_ch2_20210921024149_T.jpg": 2055,
	"./GAMKONORA_ch2_20210921025649_T.jpg": 2056,
	"./GAMKONORA_ch2_20210921031149_T.jpg": 2057,
	"./GAMKONORA_ch2_20210921032649_T.jpg": 2058,
	"./GAMKONORA_ch2_20210921034149_T.jpg": 2059,
	"./GAMKONORA_ch2_20210921035649_T.jpg": 2060,
	"./GAMKONORA_ch2_20210921041149_T.jpg": 2061,
	"./GAMKONORA_ch2_20210921042649_T.jpg": 2062,
	"./GAMKONORA_ch2_20210921044149_T.jpg": 2063,
	"./GAMKONORA_ch2_20210921045649_T.jpg": 2064,
	"./GAMKONORA_ch2_20210921051149_T.jpg": 2065,
	"./GAMKONORA_ch2_20210921052649_T.jpg": 2066,
	"./GAMKONORA_ch2_20210921054149_T.jpg": 2067,
	"./GAMKONORA_ch2_20210921055649_T.jpg": 2068,
	"./GAMKONORA_ch2_20210921061149_T.jpg": 2069,
	"./GAMKONORA_ch2_20210921062649_T.jpg": 2070,
	"./GAMKONORA_ch2_20210921064149_T.jpg": 2071,
	"./GAMKONORA_ch2_20210921065649_T.jpg": 2072,
	"./GAMKONORA_ch2_20210921071149_T.jpg": 2073,
	"./GAMKONORA_ch2_20210921072649_T.jpg": 2074,
	"./GAMKONORA_ch2_20210921074149_T.jpg": 2075,
	"./GAMKONORA_ch2_20210921075649_T.jpg": 2076,
	"./GAMKONORA_ch2_20210921081149_T.jpg": 2077,
	"./GAMKONORA_ch2_20210921082649_T.jpg": 2078,
	"./GAMKONORA_ch2_20210921084149_T.jpg": 2079,
	"./GAMKONORA_ch2_20210921085649_T.jpg": 2080,
	"./GAMKONORA_ch2_20210921091149_T.jpg": 2081,
	"./GAMKONORA_ch2_20210921092649_T.jpg": 2082,
	"./GAMKONORA_ch2_20210921094149_T.jpg": 2083,
	"./GAMKONORA_ch2_20210921095649_T.jpg": 2084,
	"./GAMKONORA_ch2_20210921101149_T.jpg": 2085,
	"./GAMKONORA_ch2_20210921102649_T.jpg": 2086,
	"./GAMKONORA_ch2_20210921104149_T.jpg": 2087,
	"./GAMKONORA_ch2_20210921105649_T.jpg": 2088,
	"./GAMKONORA_ch2_20210921111149_T.jpg": 2089,
	"./GAMKONORA_ch2_20210921112649_T.jpg": 2090,
	"./GAMKONORA_ch2_20210921114149_T.jpg": 2091,
	"./GAMKONORA_ch2_20210921115649_T.jpg": 2092,
	"./GAMKONORA_ch2_20210921121149_T.jpg": 2093,
	"./GAMKONORA_ch2_20210921122649_T.jpg": 2094,
	"./GAMKONORA_ch2_20210921124149_T.jpg": 2095,
	"./GAMKONORA_ch2_20210921125649_T.jpg": 2096,
	"./GAMKONORA_ch2_20210921131149_T.jpg": 2097,
	"./GAMKONORA_ch2_20210921132649_T.jpg": 2098,
	"./GAMKONORA_ch2_20210921134149_T.jpg": 2099,
	"./GAMKONORA_ch2_20210921135649_T.jpg": 2100,
	"./GAMKONORA_ch3_20210921001149_T.jpg": 2101,
	"./GAMKONORA_ch3_20210921002649_T.jpg": 2102,
	"./GAMKONORA_ch3_20210921004149_T.jpg": 2103,
	"./GAMKONORA_ch3_20210921005649_T.jpg": 2104,
	"./GAMKONORA_ch3_20210921011149_T.jpg": 2105,
	"./GAMKONORA_ch3_20210921012649_T.jpg": 2106,
	"./GAMKONORA_ch3_20210921014149_T.jpg": 2107,
	"./GAMKONORA_ch3_20210921015649_T.jpg": 2108,
	"./GAMKONORA_ch3_20210921021149_T.jpg": 2109,
	"./GAMKONORA_ch3_20210921022649_T.jpg": 2110,
	"./GAMKONORA_ch3_20210921024149_T.jpg": 2111,
	"./GAMKONORA_ch3_20210921025649_T.jpg": 2112,
	"./GAMKONORA_ch3_20210921031149_T.jpg": 2113,
	"./GAMKONORA_ch3_20210921032649_T.jpg": 2114,
	"./GAMKONORA_ch3_20210921034149_T.jpg": 2115,
	"./GAMKONORA_ch3_20210921035649_T.jpg": 2116,
	"./GAMKONORA_ch3_20210921041149_T.jpg": 2117,
	"./GAMKONORA_ch3_20210921042649_T.jpg": 2118,
	"./GAMKONORA_ch3_20210921044149_T.jpg": 2119,
	"./GAMKONORA_ch3_20210921045649_T.jpg": 2120,
	"./GAMKONORA_ch3_20210921051149_T.jpg": 2121,
	"./GAMKONORA_ch3_20210921052649_T.jpg": 2122,
	"./GAMKONORA_ch3_20210921054149_T.jpg": 2123,
	"./GAMKONORA_ch3_20210921055649_T.jpg": 2124,
	"./GAMKONORA_ch3_20210921061149_T.jpg": 2125,
	"./GAMKONORA_ch3_20210921062649_T.jpg": 2126,
	"./GAMKONORA_ch3_20210921064149_T.jpg": 2127,
	"./GAMKONORA_ch3_20210921065649_T.jpg": 2128,
	"./GAMKONORA_ch3_20210921071149_T.jpg": 2129,
	"./GAMKONORA_ch3_20210921072649_T.jpg": 2130,
	"./GAMKONORA_ch3_20210921074149_T.jpg": 2131,
	"./GAMKONORA_ch3_20210921075649_T.jpg": 2132,
	"./GAMKONORA_ch3_20210921081149_T.jpg": 2133,
	"./GAMKONORA_ch3_20210921082649_T.jpg": 2134,
	"./GAMKONORA_ch3_20210921084149_T.jpg": 2135,
	"./GAMKONORA_ch3_20210921085649_T.jpg": 2136,
	"./GAMKONORA_ch3_20210921091149_T.jpg": 2137,
	"./GAMKONORA_ch3_20210921092649_T.jpg": 2138,
	"./GAMKONORA_ch3_20210921094149_T.jpg": 2139,
	"./GAMKONORA_ch3_20210921095649_T.jpg": 2140,
	"./GAMKONORA_ch3_20210921101149_T.jpg": 2141,
	"./GAMKONORA_ch3_20210921102649_T.jpg": 2142,
	"./GAMKONORA_ch3_20210921104149_T.jpg": 2143,
	"./GAMKONORA_ch3_20210921105649_T.jpg": 2144,
	"./GAMKONORA_ch3_20210921111149_T.jpg": 2145,
	"./GAMKONORA_ch3_20210921112649_T.jpg": 2146,
	"./GAMKONORA_ch3_20210921114149_T.jpg": 2147,
	"./GAMKONORA_ch3_20210921115649_T.jpg": 2148,
	"./GAMKONORA_ch3_20210921121149_T.jpg": 2149,
	"./GAMKONORA_ch3_20210921122649_T.jpg": 2150,
	"./GAMKONORA_ch3_20210921124149_T.jpg": 2151,
	"./GAMKONORA_ch3_20210921125649_T.jpg": 2152,
	"./GAMKONORA_ch3_20210921131149_T.jpg": 2153,
	"./GAMKONORA_ch3_20210921132649_T.jpg": 2154,
	"./GAMKONORA_ch3_20210921134149_T.jpg": 2155,
	"./GAMKONORA_ch3_20210921135649_T.jpg": 2156,
	"./GAMKONORA_ch4_20210921000834_T.jpg": 2157,
	"./GAMKONORA_ch4_20210921002334_T.jpg": 2158,
	"./GAMKONORA_ch4_20210921003834_T.jpg": 2159,
	"./GAMKONORA_ch4_20210921005334_T.jpg": 2160,
	"./GAMKONORA_ch4_20210921010834_T.jpg": 2161,
	"./GAMKONORA_ch4_20210921012334_T.jpg": 2162,
	"./GAMKONORA_ch4_20210921013834_T.jpg": 2163,
	"./GAMKONORA_ch4_20210921015334_T.jpg": 2164,
	"./GAMKONORA_ch4_20210921020834_T.jpg": 2165,
	"./GAMKONORA_ch4_20210921022334_T.jpg": 2166,
	"./GAMKONORA_ch4_20210921023834_T.jpg": 2167,
	"./GAMKONORA_ch4_20210921025334_T.jpg": 2168,
	"./GAMKONORA_ch4_20210921030834_T.jpg": 2169,
	"./GAMKONORA_ch4_20210921032334_T.jpg": 2170,
	"./GAMKONORA_ch4_20210921033834_T.jpg": 2171,
	"./GAMKONORA_ch4_20210921035334_T.jpg": 2172,
	"./GAMKONORA_ch4_20210921040834_T.jpg": 2173,
	"./GAMKONORA_ch4_20210921042334_T.jpg": 2174,
	"./GAMKONORA_ch4_20210921043834_T.jpg": 2175,
	"./GAMKONORA_ch4_20210921045334_T.jpg": 2176,
	"./GAMKONORA_ch4_20210921050834_T.jpg": 2177,
	"./GAMKONORA_ch4_20210921052334_T.jpg": 2178,
	"./GAMKONORA_ch4_20210921053834_T.jpg": 2179,
	"./GAMKONORA_ch4_20210921055334_T.jpg": 2180,
	"./GAMKONORA_ch4_20210921060834_T.jpg": 2181,
	"./GAMKONORA_ch4_20210921062334_T.jpg": 2182,
	"./GAMKONORA_ch4_20210921063834_T.jpg": 2183,
	"./GAMKONORA_ch4_20210921065334_T.jpg": 2184,
	"./GAMKONORA_ch4_20210921070834_T.jpg": 2185,
	"./GAMKONORA_ch4_20210921072334_T.jpg": 2186,
	"./GAMKONORA_ch4_20210921073834_T.jpg": 2187,
	"./GAMKONORA_ch4_20210921075334_T.jpg": 2188,
	"./GAMKONORA_ch4_20210921080834_T.jpg": 2189,
	"./GAMKONORA_ch4_20210921082334_T.jpg": 2190,
	"./GAMKONORA_ch4_20210921083834_T.jpg": 2191,
	"./GAMKONORA_ch4_20210921085334_T.jpg": 2192,
	"./GAMKONORA_ch4_20210921090834_T.jpg": 2193,
	"./GAMKONORA_ch4_20210921092334_T.jpg": 2194,
	"./GAMKONORA_ch4_20210921093834_T.jpg": 2195,
	"./GAMKONORA_ch4_20210921095334_T.jpg": 2196,
	"./GAMKONORA_ch4_20210921100834_T.jpg": 2197,
	"./GAMKONORA_ch4_20210921102334_T.jpg": 2198,
	"./GAMKONORA_ch4_20210921103834_T.jpg": 2199,
	"./GAMKONORA_ch4_20210921105334_T.jpg": 2200,
	"./GAMKONORA_ch4_20210921110834_T.jpg": 2201,
	"./GAMKONORA_ch4_20210921112334_T.jpg": 2202,
	"./GAMKONORA_ch4_20210921113834_T.jpg": 2203,
	"./GAMKONORA_ch4_20210921115334_T.jpg": 2204,
	"./GAMKONORA_ch4_20210921120834_T.jpg": 2205,
	"./GAMKONORA_ch4_20210921122334_T.jpg": 2206,
	"./GAMKONORA_ch4_20210921123834_T.jpg": 2207,
	"./GAMKONORA_ch4_20210921125334_T.jpg": 2208,
	"./GAMKONORA_ch4_20210921130834_T.jpg": 2209,
	"./GAMKONORA_ch4_20210921132334_T.jpg": 2210,
	"./GAMKONORA_ch4_20210921133834_T.jpg": 2211,
	"./GAMKONORA_ch4_20210921135334_T.jpg": 2212,
	"./GAMKONORA_ch5_20210921001151_T.jpg": 2213,
	"./GAMKONORA_ch5_20210921002651_T.jpg": 2214,
	"./GAMKONORA_ch5_20210921004151_T.jpg": 2215,
	"./GAMKONORA_ch5_20210921005651_T.jpg": 2216,
	"./GAMKONORA_ch5_20210921011151_T.jpg": 2217,
	"./GAMKONORA_ch5_20210921012651_T.jpg": 2218,
	"./GAMKONORA_ch5_20210921014151_T.jpg": 2219,
	"./GAMKONORA_ch5_20210921015651_T.jpg": 2220,
	"./GAMKONORA_ch5_20210921021151_T.jpg": 2221,
	"./GAMKONORA_ch5_20210921022651_T.jpg": 2222,
	"./GAMKONORA_ch5_20210921024151_T.jpg": 2223,
	"./GAMKONORA_ch5_20210921025651_T.jpg": 2224,
	"./GAMKONORA_ch5_20210921031151_T.jpg": 2225,
	"./GAMKONORA_ch5_20210921032651_T.jpg": 2226,
	"./GAMKONORA_ch5_20210921034151_T.jpg": 2227,
	"./GAMKONORA_ch5_20210921035651_T.jpg": 2228,
	"./GAMKONORA_ch5_20210921041151_T.jpg": 2229,
	"./GAMKONORA_ch5_20210921042651_T.jpg": 2230,
	"./GAMKONORA_ch5_20210921044151_T.jpg": 2231,
	"./GAMKONORA_ch5_20210921045651_T.jpg": 2232,
	"./GAMKONORA_ch5_20210921051151_T.jpg": 2233,
	"./GAMKONORA_ch5_20210921052651_T.jpg": 2234,
	"./GAMKONORA_ch5_20210921054151_T.jpg": 2235,
	"./GAMKONORA_ch5_20210921055651_T.jpg": 2236,
	"./GAMKONORA_ch5_20210921061151_T.jpg": 2237,
	"./GAMKONORA_ch5_20210921062651_T.jpg": 2238,
	"./GAMKONORA_ch5_20210921064151_T.jpg": 2239,
	"./GAMKONORA_ch5_20210921065651_T.jpg": 2240,
	"./GAMKONORA_ch5_20210921071151_T.jpg": 2241,
	"./GAMKONORA_ch5_20210921072651_T.jpg": 2242,
	"./GAMKONORA_ch5_20210921074151_T.jpg": 2243,
	"./GAMKONORA_ch5_20210921075651_T.jpg": 2244,
	"./GAMKONORA_ch5_20210921081151_T.jpg": 2245,
	"./GAMKONORA_ch5_20210921082651_T.jpg": 2246,
	"./GAMKONORA_ch5_20210921084151_T.jpg": 2247,
	"./GAMKONORA_ch5_20210921085651_T.jpg": 2248,
	"./GAMKONORA_ch5_20210921091151_T.jpg": 2249,
	"./GAMKONORA_ch5_20210921092651_T.jpg": 2250,
	"./GAMKONORA_ch5_20210921094151_T.jpg": 2251,
	"./GAMKONORA_ch5_20210921095651_T.jpg": 2252,
	"./GAMKONORA_ch5_20210921101151_T.jpg": 2253,
	"./GAMKONORA_ch5_20210921102651_T.jpg": 2254,
	"./GAMKONORA_ch5_20210921104151_T.jpg": 2255,
	"./GAMKONORA_ch5_20210921105651_T.jpg": 2256,
	"./GAMKONORA_ch5_20210921111151_T.jpg": 2257,
	"./GAMKONORA_ch5_20210921112651_T.jpg": 2258,
	"./GAMKONORA_ch5_20210921114151_T.jpg": 2259,
	"./GAMKONORA_ch5_20210921115651_T.jpg": 2260,
	"./GAMKONORA_ch5_20210921121151_T.jpg": 2261,
	"./GAMKONORA_ch5_20210921122651_T.jpg": 2262,
	"./GAMKONORA_ch5_20210921124151_T.jpg": 2263,
	"./GAMKONORA_ch5_20210921125651_T.jpg": 2264,
	"./GAMKONORA_ch5_20210921131151_T.jpg": 2265,
	"./GAMKONORA_ch5_20210921132651_T.jpg": 2266,
	"./GAMKONORA_ch5_20210921134151_T.jpg": 2267,
	"./GAMKONORA_ch5_20210921135651_T.jpg": 2268,
	"./GAMKONORA_ch6_20210921001151_T.jpg": 2269,
	"./GAMKONORA_ch6_20210921002651_T.jpg": 2270,
	"./GAMKONORA_ch6_20210921004151_T.jpg": 2271,
	"./GAMKONORA_ch6_20210921005651_T.jpg": 2272,
	"./GAMKONORA_ch6_20210921011151_T.jpg": 2273,
	"./GAMKONORA_ch6_20210921012651_T.jpg": 2274,
	"./GAMKONORA_ch6_20210921014151_T.jpg": 2275,
	"./GAMKONORA_ch6_20210921015651_T.jpg": 2276,
	"./GAMKONORA_ch6_20210921021151_T.jpg": 2277,
	"./GAMKONORA_ch6_20210921022651_T.jpg": 2278,
	"./GAMKONORA_ch6_20210921024151_T.jpg": 2279,
	"./GAMKONORA_ch6_20210921025651_T.jpg": 2280,
	"./GAMKONORA_ch6_20210921031151_T.jpg": 2281,
	"./GAMKONORA_ch6_20210921032651_T.jpg": 2282,
	"./GAMKONORA_ch6_20210921034151_T.jpg": 2283,
	"./GAMKONORA_ch6_20210921035651_T.jpg": 2284,
	"./GAMKONORA_ch6_20210921041151_T.jpg": 2285,
	"./GAMKONORA_ch6_20210921042651_T.jpg": 2286,
	"./GAMKONORA_ch6_20210921044151_T.jpg": 2287,
	"./GAMKONORA_ch6_20210921045651_T.jpg": 2288,
	"./GAMKONORA_ch6_20210921051151_T.jpg": 2289,
	"./GAMKONORA_ch6_20210921052651_T.jpg": 2290,
	"./GAMKONORA_ch6_20210921054151_T.jpg": 2291,
	"./GAMKONORA_ch6_20210921055651_T.jpg": 2292,
	"./GAMKONORA_ch6_20210921061151_T.jpg": 2293,
	"./GAMKONORA_ch6_20210921062651_T.jpg": 2294,
	"./GAMKONORA_ch6_20210921064151_T.jpg": 2295,
	"./GAMKONORA_ch6_20210921065651_T.jpg": 2296,
	"./GAMKONORA_ch6_20210921071151_T.jpg": 2297,
	"./GAMKONORA_ch6_20210921072651_T.jpg": 2298,
	"./GAMKONORA_ch6_20210921074151_T.jpg": 2299,
	"./GAMKONORA_ch6_20210921075651_T.jpg": 2300,
	"./GAMKONORA_ch6_20210921081151_T.jpg": 2301,
	"./GAMKONORA_ch6_20210921082651_T.jpg": 2302,
	"./GAMKONORA_ch6_20210921084151_T.jpg": 2303,
	"./GAMKONORA_ch6_20210921085651_T.jpg": 2304,
	"./GAMKONORA_ch6_20210921091151_T.jpg": 2305,
	"./GAMKONORA_ch6_20210921092651_T.jpg": 2306,
	"./GAMKONORA_ch6_20210921094151_T.jpg": 2307,
	"./GAMKONORA_ch6_20210921095651_T.jpg": 2308,
	"./GAMKONORA_ch6_20210921101151_T.jpg": 2309,
	"./GAMKONORA_ch6_20210921102651_T.jpg": 2310,
	"./GAMKONORA_ch6_20210921104151_T.jpg": 2311,
	"./GAMKONORA_ch6_20210921105651_T.jpg": 2312,
	"./GAMKONORA_ch6_20210921111151_T.jpg": 2313,
	"./GAMKONORA_ch6_20210921112651_T.jpg": 2314,
	"./GAMKONORA_ch6_20210921114151_T.jpg": 2315,
	"./GAMKONORA_ch6_20210921115651_T.jpg": 2316,
	"./GAMKONORA_ch6_20210921121151_T.jpg": 2317,
	"./GAMKONORA_ch6_20210921122651_T.jpg": 2318,
	"./GAMKONORA_ch6_20210921124151_T.jpg": 2319,
	"./GAMKONORA_ch6_20210921125651_T.jpg": 2320,
	"./GAMKONORA_ch6_20210921131151_T.jpg": 2321,
	"./GAMKONORA_ch6_20210921132651_T.jpg": 2322,
	"./GAMKONORA_ch6_20210921134151_T.jpg": 2323,
	"./GAMKONORA_ch6_20210921135651_T.jpg": 2324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1988;